/**
 * Safely accesses nested object properties using a path string
 * @param obj The object to access
 * @param path The path string (e.g., 'a.b.c')
 * @param defaultValue The default value if path doesn't exist
 * @returns The value at the path or defaultValue
 */
export const getNestedValue = (
  obj: Record<string, any>,
  path: string,
  defaultValue: any = null,
): any => {
  if (!path || typeof path !== 'string') return defaultValue;
  const keys = path.split('.');
  const result = keys.reduce((cur: any, key: string) => cur?.[key], obj);
  return result !== undefined ? result : defaultValue;
};
